// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DWwc","col":"styles_col__I-SKa"};